<script setup>
const { y } = useWindowScroll()

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
</script>

<template>
  <VScaleTransition
    style="transform-origin: center;"
    class="scroll-to-top d-print-none"
  >
    <VBtn
      v-show="y > 200"
      icon
      density="comfortable"
      @click="scrollToTop"
    >
      <VIcon
        size="22"
        icon="tabler-arrow-up"
      />
    </VBtn>
  </VScaleTransition>
</template>

<style lang="scss">
.scroll-to-top {
  position: fixed !important;

  // To keep button on top of v-layout. E.g. Email app
  z-index: 999;
  // 與批次操作浮動列（AppBatchActionBar）垂直置中對齊：
  // 浮動列底距 1rem、高 48px，本按鈕高 38px，(48 - 38) / 2 = 5px。
  // 浮動列的高度或底距一改，這個 5px 就要重算，兩支檔案要一起調
  inset-block-end: calc(1rem + 5px);
  inset-inline-end: 25px;
}
</style>
